<script setup lang="ts">
import { injectStepperRootContext } from "reka-ui";

const props = defineProps<{
	step: number;
}>();

const { modelValue: currentStep } = injectStepperRootContext();
</script>

<template>
	<slot v-if="currentStep === props.step" />
</template>
